'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('documents', {
      url: '/account/toc_policy/documents',
      template: '<documents></documents>'
    });
}



// WEBPACK FOOTER //
// ./client/app/account/toc_policy/documents/documents.routes.js